(function() {
    'use strict';

    angular
    .module('valueconnectApp')
    .controller('OriginatorAppraiserDirectNoteMessageboardController', OriginatorAppraiserDirectNoteMessageboardController);

    OriginatorAppraiserDirectNoteMessageboardController.$inject = ['$state', 'order', 'dashboard', 'hasInsertRole', '$mdDialog', 'account'];

    function OriginatorAppraiserDirectNoteMessageboardController ($state, order, dashboard, hasInsertRole, $mdDialog, account) {

        var vm = this;

        // Entities
        vm.hasInsertPermission = hasInsertRole && account.enableDirectMessageBoard;
        vm.order = order;
        // Role-aware send gate (DirectMessageBoardPolicy): same rule the API enforces on save.
        vm.canCurrentUserPost = dashboard.canCurrentUserPost;
        vm.notes = dashboard.notes;
        vm.account = account;

        vm.orderAddress = [vm.order.address.address1, vm.order.address.cityName, vm.order.address.provinceName].filter(Boolean).join(', ');

        // Methods
        vm.createNote = createNote;

        function createNote() {
            $mdDialog.show({
                templateUrl: 'app/entities/originator-appraiser-direct-note/originator-appraiser-direct-note-dialog.html',
                controller: 'OriginatorAppraiserDirectNoteDialogController',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                resolve: {
                    entity: function () {
                        return {
                            note: null,
                            read: false,
                            appraisalOrderId: vm.order.id
                        };
                    }
                }
            })
            .then(
                function(data) {
                    $state.go('originator-appraiser-direct-note-messageboard', null, { reload: true });
                }, function() {
                    $state.go('originator-appraiser-direct-note-messageboard');
                }
            );
        }

    }
})();
